const AngleUpSmallOutlined = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='none' viewBox='0 0 14 14'>
    <path
      fill='#25314C'
      d='M9.333 8.603a.43.43 0 0 1-.31-.128L7 6.451 4.976 8.475a.438.438 0 1 1-.62-.619L6.69 5.523c.17-.171.448-.171.619 0l2.333 2.333a.438.438 0 0 1-.309.747'
    />
  </svg>
);

export default AngleUpSmallOutlined;
